import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">精彩视频</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">PV首发、作者访谈、限免活动，精彩内容一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl md:rounded-2xl overflow-hidden border border-background-200/70 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl md:text-2xl w-5 h-5 md:w-6 md:h-6 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-[10px] md:text-xs px-2 py-0.5 rounded-full font-medium">{item.tag}</div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{item.desc}</p>
                <div className="flex items-center justify-between text-[10px] md:text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {item.views}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}